import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 商品详情页事件名称常量
export const DP_EVENT_NAMES = {
  MAIN_IMAGE_LOAD_ERROR: 'main_image_load_error',
  MAIN_VIDEO_PLAY_ERROR: 'main_video_play_error',
  ADD_CART_BUTTON_CLICK: 'add_cart_button_click',
  NOW_BUY_BUTTON_CLICK: 'now_buy_button_click',
  PRODUCT_COUNTER_CHANGE: 'product_counter_change',
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type DpEventNames = typeof DP_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const dpBusinessLogger = createBusinessLogger<DpEventNames>('dp', categoryNames);
